angular.module('bribac.components.noteEditor', [
  'focus-if',
  'bribac.validators.requiredWithTrim'
])

  .component('noteEditor', {
    templateUrl: 'note-editor-component.html',
    bindings: {
      form: '<',
      note: '<',
      autoFocus: '<'
    }
  })
